
import { useEffect, useState } from "react"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"
import { videoService } from "@/services/video.service"
import type { Video } from "@/types/api"

interface VideoSelectProps {
    value?: string
    onChange: (value: string) => void
}

export function VideoSelect({ value, onChange }: VideoSelectProps) {
    const [videos, setVideos] = useState<Video[]>([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const fetchVideos = async () => {
            setIsLoading(true)
            try {
                // Fetch all videos (or first 100)
                const response = await videoService.getVideos({ limit: 100 })
                setVideos(response.results)
            } catch (error) {
                console.error("Failed to fetch videos", error)
            } finally {
                setIsLoading(false)
            }
        }
        fetchVideos()
    }, [])

    return (
        <Select value={value ? String(value) : undefined} onValueChange={onChange} disabled={isLoading}>
            <SelectTrigger>
                <SelectValue placeholder={isLoading ? "Loading videos..." : "Select a video"} />
            </SelectTrigger>
            <SelectContent>
                {videos.map((video) => (
                    <SelectItem key={video.id} value={String(video.id)}>
                        <div className="flex items-center gap-2">
                            <span>{video.title}</span>
                            <span className="text-xs text-gray-400">({video.duration_formatted})</span>
                        </div>
                    </SelectItem>
                ))}
                {videos.length === 0 && !isLoading && (
                    <div className="p-2 text-sm text-gray-500 text-center">No videos found</div>
                )}
            </SelectContent>
        </Select>
    )
}
